module.exports = __webpack_public_path__ + "assets-wl/images/ring.gif?c70e6842";